import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function OpenRolesSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section id="open-roles" className="py-16 md:py-20 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/70 border border-accent-200/50 mb-4">
            <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">Open Roles</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-primary-700 mb-4">
            Find Your Place
          </h2>
        </div>

        {/* Empty state */}
        <div className="max-w-lg mx-auto text-center bg-card-50 rounded-2xl border border-card-200 p-10 md:p-14 shadow-sm">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-secondary-100 flex items-center justify-center animate-icon-float icon-hover-pop">
            <i className="ri-briefcase-line text-3xl text-secondary-600"></i>
          </div>
          <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
            Currently No Open Positions
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6">
            We do not have any active openings right now. Please check back later — we are growing fast and new roles open up regularly.
          </p>
          <p className="text-xs text-foreground-400 leading-relaxed max-w-sm mx-auto">
            If you believe you can make a difference at Freshhlock, send your resume and a note about what you would build to{' '}
            <span className="text-primary-600 font-medium">careers@freshhlock.com</span>.
            We read every email.
          </p>
        </div>
      </div>
    </section>
  );
}